import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TenantProductServiceTaxesDto } from '@shared/service-proxies/service-proxies';
import { exit } from 'process';

@Component({
  selector: 'app-add-taxes-setting',
  templateUrl: './add-taxes-setting.component.html',
  styleUrls: ['./add-taxes-setting.component.css']
})
export class AddTaxesSettingComponent implements OnInit {
  @Input() showtaxmodel:boolean;
  @Input() EditDataVals:TenantProductServiceTaxesDto[];
  @Output() value = new EventEmitter<boolean>();
  @Output() TaxData = new EventEmitter<TenantProductServiceTaxesDto[]>();

  containers: TenantProductServiceTaxesDto[] = new Array<TenantProductServiceTaxesDto>();
  checkedtaxes: TenantProductServiceTaxesDto[] = new Array<TenantProductServiceTaxesDto>();
  amount: number=0;
  maxNo: boolean=false;
  addtaxshow: boolean=true;
  Id: number=1;
  taxIdNameNotAdded: boolean=false;
  constructor() { }

  ngOnInit(): void {
    this.containers=this.EditDataVals.length ? this.EditDataVals: this.containers;
    if (this.containers.length === 0) {
      this.addTax()
    }
    
  }
  ngOnChanges(){
    this.containers=this.EditDataVals.length ? this.EditDataVals: this.containers;
    
  }

  onlyNumberKey(event) {
    return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  onChange(isChecked: boolean) {
    if (isChecked) {
        this.amount++;
    } else {
        this.amount--;
    }
    this.amount === 2 ? this.maxNo = true : this.maxNo = false;
  }
  toclosed=false;
  ClosetaxModel(){
    this.containers=[];
    this.addTax();
    //this.showtaxmodel=!this.showtaxmodel;
     
    this.toclosed = true;
    this.value.emit(this.toclosed);
  }
  addTax() {
    this.taxFormSubmitted = false;
    if (this.containers.length <= 5) {
        let tax= new TenantProductServiceTaxesDto();
        //tax.id=this.Id++;
        // tax.taxName= null;
        // tax.taxNumber=null;
        // tax.taxRate=null;

        this.containers.push(tax);
    }
  }

  deleteTax(index: number) {
      this.containers.splice(index, 1);
  }

  taxFormSubmitted:boolean=false;
  applytaxes(){
    !this.containers?.length ? this.addTax() : null;
    this.taxFormSubmitted = true;
    this.taxIdNameNotAdded = false;
    this.containers.forEach(element => {
      if(!element.taxName || element.taxRate == undefined || element.taxRate == null ){
        this.taxIdNameNotAdded = true;
      }
    });
    if(this.taxIdNameNotAdded){
      return;
    }

    
    this.toclosed = true;
    this.value.emit(this.toclosed);
    this.TaxData.emit(this.containers);
    this.addtaxshow = false;
  }

  dataReturn(){
    // this.containers.forEach((x,i) => {
    //   
    //   if(!x.taxName || !x.taxNumber || !x.taxRate){
    //     this.containers.splice(i,1);
    //   }
    // });
    this.containers=this.containers.filter(x => !(!x.taxName));
    
    return this.containers;
  }

  editTax(editFieldArray:TenantProductServiceTaxesDto[]){
    
    //this.containers=editFieldArray;
    if(editFieldArray.length === 0 || !editFieldArray){
      this.containers=[];
      this.addTax();
    }else{
      this.deleteTax(0);
        this.containers=editFieldArray;
    }
  }
}
function input() {
  throw new Error('Function not implemented.');
}

